<template>
	<div>
		<input
			@keydown.backspace="handleTimerInputBack"
			@keydown="handleTimerKeydown"
			@blur="sanitizeInput('minutes')"
			:value='minutes'
			autocomplete="off"
			data-lpignore="true"
			ref="timer-min"
			class="w-10 mb-3 rounded border border-gray-200 p-2 text-center appearance-none"
			type="text"
			maxlength="2"
		 >
		<b class='mr-1 ml-1'>:</b>
		<input
			@keydown.backspace="handleTimerInputBack"
			@keydown="handleTimerKeydown"
			@blur="sanitizeInput('seconds')"
			:value='seconds'
			autocomplete="off"
			data-lpignore="true"
			ref="timer-sec"
			class="w-10 mb-3 rounded border border-gray-200 p-2 text-center appearance-none"
			type="text"
			maxlength="2"
		>
	</div>
</template>

<script>
export default {
	name: 'timer-countdown',
	props: {
		minutes: String,
		seconds: String
	},
	methods: {
		sanitizeInput(model) {
			if(model=='seconds') {
				const seconds = Number(this.$refs['timer-sec'].value)
				this.$emit('update:seconds', seconds > 9 ? `${seconds}` : `0${seconds}`)
			}else if(model=='minutes') {
				const minutes = Number(this.$refs['timer-min'].value)
				this.$emit('update:minutes', minutes > 9 ? `${minutes}` : `0${minutes}`)
			}
		},
		handleTimerInputBack(ev) {
			if (ev.target.value.length < 1 && ev.target === this.$refs["timer-sec"]) {
				this.$nextTick(() => {
					this.$refs["timer-min"].focus();
				});
			}
			return true;
		},
		handleTimerKeydown(e) {
			const validKey = [8, 9, 16];
			const isNumeric = (e.keyCode >= 48 && e.keyCode <= 57) || (e.keyCode >= 96 && e.keyCode <= 105) || validKey.indexOf(e.keyCode) > -1;
			if (!isNumeric)
				e.preventDefault();
			else {
				setTimeout(() => {
					if (this.$refs['timer-sec'].value > 59) {
						const minutes = Number(this.minutes) + Math.floor(this.seconds / 60);
						const seconds = Math.ceil(this.seconds % 60);
						this.$emit('update:minutes', minutes > 9 ? `${minutes}` : `0${minutes}`);
						this.$emit('update:seconds', seconds > 9 ? `${seconds}` : `0${seconds}`);
					}else{
						this.$emit('update:minutes', this.$refs['timer-min'].value);
						this.$emit('update:seconds', this.$refs['timer-sec'].value);
					}
				}, 500);
			}
		},
	}
}
</script>

<style>

</style>